<ng-container *ngIf="notes$ | async as notes">
  <div
    *ngIf="selectedNote$ | async as selectedNote"
    class="list-wrapper"
    [ngClass]="{ 'mail-selected': selectedNote && selectedNote.id }"
  >
    <!-- Mail list header -->
    <div class="header">
      <!-- Header left -->
      <div class="left">
        <!-- Category name -->
        <div class="category">Notes</div>
      </div>

      <div class="pagination">
        <!-- Previous page button -->
        <button
          mat-icon-button
          (click)="addNote()"
          data-cy="open-add-notes"
          [appAuthorize]="getEditPermission()"
          denyAction="disable"
        >
          <mat-icon [svgIcon]="'add_circle_outline'"></mat-icon>
        </button>
      </div>

      <!-- Loading bar -->
      <mat-progress-bar class="loading-progress-bar" *ngIf="isLoading" [mode]="'indeterminate'"></mat-progress-bar>
    </div>

    <!-- Mail list -->
    <div class="list" #noteList>
      <!-- Mail list item loop -->
      <ng-container *ngFor="let note of notes; let i = index; trackBy: trackByFn">
        <!-- Mail list item -->
        <a
          class="item"
          [ngClass]="{ selected: selectedNote && selectedNote.id === note.id }"
          [routerLink]="[note.id]"
          data-cy="note-item"
        >
          <div class="item-content">
            <!-- Info -->
            <div class="info">
              <!-- Sender name -->
              <div class="name">
                {{ note.user_name }}
              </div>

              <!-- Date -->
              <div class="date">
                {{ note.created_at | date: 'LLL dd, y' }}
              </div>
            </div>

            <!-- Subject -->
            <div class="subject">
              <span>{{ note.title }}</span>
            </div>
          </div>
        </a>
      </ng-container>
    </div>

    <mat-paginator
      *ngIf="pagination$ | async as pagination"
      [ngClass]="{ loading: isLoading }"
      [length]="pagination.notesCount"
      [pageSize]="10"
      [pageIndex]="pagination.page"
      [showFirstLastButtons]="true"
      hidePageSize="true"
    >
    </mat-paginator>
  </div>

  <router-outlet *ngIf="notes?.length > 0"></router-outlet>
</ng-container>
